// extracted by mini-css-extract-plugin
export default {"Film":"CatalogItemLabel_Film__k4TX2","Serial":"CatalogItemLabel_Serial__L1xVe","Show":"CatalogItemLabel_Show__38Jbc","new":"CatalogItemLabel_new__rqjCm"};